/**
 * One-shot marker that says "an account was just created on this browser",
 * so the Google Ads signup conversion can fire client-side after the redirect.
 *
 * Why a cookie rather than a success page: onboarding lands somewhere
 * different every time — the dashboard, a seeded competitor preview, or an
 * explicit `redirectTo` — so there is no single page to tag. The generic
 * mechanism, and why the URL is not an option, is documented in
 * `conversion-marker.ts`.
 *
 * Deleted only on a CONFIRMED fire, so a page loaded before gtag finishes
 * initialising retries on the next navigation instead of silently losing the
 * conversion.
 */
import {
	clearConversionMarker,
	conversionMarkerCookie,
	hasConversionMarker,
} from './conversion-marker.ts'

export const SIGNUP_CONVERSION_COOKIE = 'cb_signup_conversion'

/**
 * `Set-Cookie` value to append to an onboarding response (server side).
 */
export function signupConversionCookie(): string {
	return conversionMarkerCookie(SIGNUP_CONVERSION_COOKIE)
}

/** True when this browser just completed signup (client side). */
export function hasSignupConversionMarker(): boolean {
	return hasConversionMarker(SIGNUP_CONVERSION_COOKIE)
}

/** Removes the marker. Call only once the conversion actually fired. */
export function clearSignupConversionMarker(): void {
	clearConversionMarker(SIGNUP_CONVERSION_COOKIE)
}
